import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'components/Modal';
import useUniqueId from 'hooks/useUniqueId';
import StickyButtonPanel from 'components/StickyButtonPanel';
import Button from 'components/Button';
import ModalHeadline from 'components/ModalHeadline';
import Card from 'components/Card';
import EmptyStateController from 'components/EmptyStateController';
import { StickyEditorPageHeaderWrapper } from 'components/EditorPageHeader';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var AddModalFormWrapper = function AddModalFormWrapper(_ref) {
  var assetContentType = _ref.assetContentType,
    inContentManagerContext = _ref.inContentManagerContext,
    isSaving = _ref.isSaving,
    isError = _ref.isError,
    isLoading = _ref.isLoading,
    isSubmitDisabled = _ref.isSubmitDisabled,
    children = _ref.children,
    onSubmit = _ref.onSubmit,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            onSubmit();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var titleId = useUniqueId();
  var title = t(assetContentType ? "actions_add_".concat(assetContentType) : 'actions_add');
  return /*#__PURE__*/_jsxs(Modal, {
    "aria-labelledby": titleId,
    onRequestClose: onClose,
    layout: "top-aligned",
    width: "fullPage",
    children: [/*#__PURE__*/_jsx(StickyEditorPageHeaderWrapper, {
      children: /*#__PURE__*/_jsx(Card, {
        variant: "raised",
        children: /*#__PURE__*/_jsx(ModalHeadline, {
          sticky: true,
          title: title,
          titleId: titleId,
          onClose: onClose
        })
      })
    }), /*#__PURE__*/_jsxs("form", {
      onSubmit: handleSubmit,
      children: [/*#__PURE__*/_jsx(EmptyStateController, {
        showContentInCards: true,
        isLoading: isLoading,
        isError: isError,
        height: 'calc(100dvh - 200px)',
        children: children
      }), /*#__PURE__*/_jsx(StickyButtonPanel, {
        mt: "m",
        p: "0",
        children: /*#__PURE__*/_jsx(Card, {
          variant: "raised",
          p: "m",
          children: /*#__PURE__*/_jsx(Button, {
            type: "submit",
            variant: "primary",
            isDisabled: isSubmitDisabled,
            isLoading: isSaving,
            children: t(inContentManagerContext ? 'actions_done' : 'actions_save_and_close')
          })
        })
      })]
    })]
  });
};
export default AddModalFormWrapper;